import React from "react";

export default function LableText({ children, required = true }) {
  return (
    <p className="my-0">
      {children} {required && <span className="danger mr-0">*</span>}
    </p>
  );
}
